import { ArrowDownLeft, ArrowUpRight, History, Receipt, Smartphone } from "lucide-react";

const ActionTile = ({ icon: Icon, label }) => (
  <div className="flex flex-col items-center gap-1.5 rounded-lg border border-gray-200 py-2.5">
    <Icon className="h-4 w-4 text-brand" aria-hidden="true" />
    <span className="text-[10px] font-medium text-gray-600">{label}</span>
  </div>
);

const HistoryRow = ({ icon: Icon, label, meta }) => (
  <div className="flex items-center gap-2.5 border-b border-gray-100 py-2.5 last:border-0">
    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-gray-50">
      <Icon className="h-3.5 w-3.5 text-brand" aria-hidden="true" />
    </span>
    <div className="min-w-0 flex-1">
      <p className="truncate text-[11px] font-semibold text-gray-800">{label}</p>
      <p className="text-[10px] text-gray-400">{meta}</p>
    </div>
    <span className="text-[9px] font-medium text-emerald-600">Completed</span>
  </div>
);

const HomeScreen = () => (
  <div className="flex h-full flex-col gap-3 p-3.5">
    <div className="flex items-center justify-between">
      <span className="font-heading text-xs font-extrabold text-gray-900">Banga Pay</span>
      <img
        src="/assets/banga-logo.png"
        alt=""
        className="h-6 w-6 rounded-md object-cover"
        aria-hidden="true"
      />
    </div>
    <div className="rounded-xl bg-brand p-3.5 text-white">
      <p className="text-[10px] uppercase tracking-wide text-white/70">Available balance</p>
      <p className="mt-1 font-heading text-lg font-extrabold">UGX ••••••</p>
      <p className="mt-0.5 text-[10px] text-white/70">Banga Pay wallet</p>
    </div>
    <div className="grid grid-cols-4 gap-1.5">
      <ActionTile icon={ArrowUpRight} label="Send" />
      <ActionTile icon={ArrowDownLeft} label="Receive" />
      <ActionTile icon={Receipt} label="Bills" />
      <ActionTile icon={History} label="History" />
    </div>
    <div>
      <p className="mb-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400">Recent</p>
      <HistoryRow icon={Smartphone} label="Mobile Money" meta="Today" />
      <HistoryRow icon={Receipt} label="Bill payment" meta="Yesterday" />
    </div>
  </div>
);

const SendScreen = () => (
  <div className="flex h-full flex-col gap-3 p-3.5">
    <p className="font-heading text-sm font-extrabold text-gray-900">Send Money</p>
    <div className="rounded-lg border border-gray-200 p-3">
      <p className="text-[10px] uppercase tracking-wide text-gray-400">Recipient</p>
      <p className="mt-1 text-xs font-medium text-gray-700">Name or phone number</p>
    </div>
    <div className="rounded-lg border border-gray-200 p-3">
      <p className="text-[10px] uppercase tracking-wide text-gray-400">Amount (UGX)</p>
      <p className="mt-1 font-heading text-base font-extrabold text-gray-900">••••••</p>
    </div>
    <p className="text-[10px] leading-relaxed text-gray-400">
      You will review and confirm the details before anything is sent.
    </p>
    <div className="mt-auto rounded-md bg-brand py-2.5 text-center text-xs font-semibold text-white">
      Continue
    </div>
  </div>
);

const HistoryScreen = () => (
  <div className="flex h-full flex-col gap-2 p-3.5">
    <p className="font-heading text-sm font-extrabold text-gray-900">Transactions</p>
    <div>
      <HistoryRow icon={ArrowUpRight} label="Sent money" meta="12 Jul" />
      <HistoryRow icon={ArrowDownLeft} label="Received payment" meta="10 Jul" />
      <HistoryRow icon={Receipt} label="Bill payment" meta="8 Jul" />
      <HistoryRow icon={Smartphone} label="Mobile Money" meta="5 Jul" />
      <HistoryRow icon={ArrowUpRight} label="Sent money" meta="2 Jul" />
    </div>
  </div>
);

const screens = { home: HomeScreen, send: SendScreen, history: HistoryScreen };

// Placeholder mockup. Swap these screens for real app screenshots when available.
export const PhoneMockup = ({ screen = "home" }) => {
  const Screen = screens[screen] || HomeScreen;
  return (
    <div
      data-testid={`phone-mockup-${screen}`}
      className="w-[232px] rounded-[30px] bg-gray-900 p-[6px] shadow-sm sm:w-[252px]"
    >
      <div className="overflow-hidden rounded-[24px] bg-white">
        <div className="flex items-center justify-between bg-white px-4 pt-2 text-[9px] font-medium text-gray-500">
          <span>9:41</span>
          <span className="h-3.5 w-14 rounded-full bg-gray-900" aria-hidden="true" />
          <span aria-hidden="true">•••</span>
        </div>
        <div className="h-[420px] sm:h-[440px]">
          <Screen />
        </div>
      </div>
    </div>
  );
};
